angular.module('bmsApp.dashboard')
	.controller('FeedbackBreakdownCtrl', FeedbackBreakdownCtrl);

FeedbackBreakdownCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$modalInstance',
	'feedback',
	'feedbackDates',
];

function FeedbackBreakdownCtrl(
	$scope,
	$state,
	$q,
	$modalInstance,
	feedback,
	feedbackDates,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
	});

	this.$onInit = () => {
		self.loading = false;
	};

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.init = () => {
		self.feedbackResponses = feedback;
		self.feedbackDates = feedbackDates;
	};
	handlers.cancel = () => {
		$modalInstance.dismiss('cancel');
	};
}
